var $ = require('jquery');
$(document).ready(function(){
    $('.banner-time').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        adaptiveHeight: true,
        arrows: false
    });
});